import type { ExpenseCategoryDTO } from "@/modules/expenses/domain/contracts";

export const EXPENSE_CATEGORY_LABELS: Record<ExpenseCategoryDTO, string> = {
  facebook_ads: "Facebook Ads",
  marketing: "Marketing",
  packaging: "ຄ່າແພັກ/ກ່ອງ",
  shipping_supplies: "ອຸປະກອນສົ່ງ",
  return_shipping: "ຄ່າສົ່ງຕີກັບ",
  carrier_shipping: "ຄ່າຂົນສົ່ງ (ຮ້ານຈ່າຍ)",
  rent: "ຄ່າເຊົ່າ",
  salary: "ເງິນເດືອນ",
  utilities: "ຄ່ານ້ຳ/ໄຟ",
  other: "ອື່ນໆ",
};
